module.exports = __webpack_public_path__ + "img/IMG_9786_L_Wood_MockedUp.a21e25a5.jpg";